import { PaymentActions } from "../actions";

const initialState = {
  paymentDischarge: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  jobMateraSettlementHistory: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  invoiceCompensation: {
    rows: [],
    rowCount: 0,
    pageCount: 1,
    averageDays: 0,
  },
};

export default function payment(state = initialState, action) {
  switch (action.type) {
    case PaymentActions.ACTION_SAVE_PAYMENT_DISCHARGE:
      return {
        ...state,
        paymentDischarge: action.payload,
      };
    case PaymentActions.ACTION_SAVE_JOB_MATERA_SETTLEMENT_HISTORY:
      return {
        ...state,
        jobMateraSettlementHistory: action.payload,
      };
    case PaymentActions.ACTION_SAVE_INVOICE_COMPENSATION:
      return {
        ...state,
        invoiceCompensation: action.payload,
      };
    default:
      return state;
  }
}

export function getPaymentDischarge(state) {
  return state.payment.paymentDischarge;
}

export function getJobMateraSettlementHistory(state) {
  return state.payment.jobMateraSettlementHistory;
}

export function getInvoiceCompensation(state) {
  return state.payment.invoiceCompensation || {
    rows: [],
    rowCount: 0,
    pageCount: 1,
    averageDays: 0,
  };
}

export const PaymentSelectors = {
  getPaymentDischarge,
  getJobMateraSettlementHistory,
  getInvoiceCompensation,
};
